import styled from 'styled-components'

export const ContainerDesenho = styled.div`
  width: 100%;
  display: flex;
  gap: 10px;
  padding: 0 5px 0 5px;
`
export const Painel = styled.div`
  position: absolute;
  top: 100px;
  left: 37px;
  width: 267px;
  background-color: #fff;
  border-radius: 7px;
  box-sizing: border-box;
  padding: 15px;
  display: flex;
  flex-direction: column;
  gap: 10px;
  transition: 0.4s;
`
export const Container = styled.div`
  .ant-drawer-body {
    padding: 0;
  }
`
export const Tools = styled.div`
  position: absolute;
  display: flex;
  justify-content: end;
  width: 20rem;
  height: 90vh;
  right: 0;
  margin: 1rem;
`
export const CardDados = styled.div`
  position: absolute;
  box-sizing: border-box;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  width: 350px;
  border-radius: 10px;
  right: 10px;
  top: 10px;
  background-color: white;
`